export const tipoCampanhaEnum = {
    REGIONAL: "Regional",
    NACIONAL: "Nacional"
};